import { Observable, ReplaySubject, Subject } from "rxjs";
import { shareReplay, takeUntil, tap } from "rxjs/operators";

import { Funcao } from "./models/funcao";
import { FuncaoApi } from "./api/funcao.api";
import { FuncaoState } from "./state/funcao.state";
import { Injectable } from "@angular/core";
import { catchError } from "rxjs/operators";
import { handleError } from "../shared/util/error-util";
import { indicate } from "maps-angular-components";

@Injectable()
export class FuncaoFacade {

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  constructor(
    private funcaoApi: FuncaoApi,
    private funcaoState: FuncaoState
  ) { }

  destroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  reset() {
    this.destroyed$ = new ReplaySubject<boolean>();
    this.funcaoState.reset();
  }

  getLoading$(): Observable<boolean> {
    return this.funcaoState.getLoading$();
  }

  getCategorias$(): Observable<string[]> {
    return this.funcaoState.getCategorias$();
  }

  buscarCategorias() {
    return this.funcaoApi.buscarCategorias()
      .pipe(
        takeUntil(this.destroyed$),
        indicate(this.funcaoState.getLoading$()),
        shareReplay(1),
        catchError(handleError)
      ).subscribe(
        categorias => this.funcaoState.setCategorias(categorias)
      );
  }

  getFuncoes$(): Observable<Funcao[]> {
    return this.funcaoState.getFuncoes$();
  }

  filtrarFuncoes(input: string) {
    this.funcaoState.filtrarFuncoes(input);
  }

  getFuncoesFiltradas$(): Observable<Funcao[]> {
    return this.funcaoState.getFuncoesFiltradas$();
  }

  getFuncoesFiltradasNaoAdicionadas$(): Observable<Funcao[]> {
    return this.funcaoState.getFuncoesFiltradasNaoAdicionadas$();
  }

  getFuncaoFiltradaByNome(nome: string): Funcao {
    return this.funcaoState.getFuncaoFiltradaByNome(nome);
  }

  getFuncaoSelecionada$(): Observable<Funcao> {
    return this.funcaoState.getFuncaoSelecionada$();
  }

  setFuncaoSelecionada(funcao: Funcao): void {
    return this.funcaoState.setFuncaoSelecionada(funcao);
  }

  getFuncoesAdicionadas$(): Observable<Funcao[]> {
    return this.funcaoState.getfuncoesAdicionadas$();
  }

  getFuncoesNaoAdicionadas$() {
    return this.funcaoState.getfuncoesNaoAdicionadas$();
  }

  buscarFuncoes(categoria: string) {

    return this.funcaoApi.buscarFuncoes(categoria)
      .pipe(
        takeUntil(this.destroyed$),
        shareReplay(1),
        indicate(this.funcaoState.getLoading$()),
        catchError(handleError)
      ).subscribe(
        funcoes => this.funcaoState.setFuncoes(funcoes)
      );
  }

  addFuncaoAdicionada() {
    return this.funcaoState.addFuncaoAdicionada();
  }

  removeFuncaoAdicionada(funcao: Funcao) {
    return this.funcaoState.removeFuncaoAdicionada(funcao);
  }

  baixarModelosFuncoesAdicionadas() {
    const funcoesAdicionadas = this.funcaoState.getfuncoesAdicionadas()

    return this.funcaoApi.baixarModelosFuncoes(funcoesAdicionadas)
      .pipe(
        takeUntil(this.destroyed$),
        indicate(this.funcaoState.getLoading$()),
        catchError(handleError)
      );
  }
}
